import {Injectable} from '@angular/core';
import {default as TurndownForWhat} from 'turndown';

@Injectable({
  providedIn: 'root',
})
export class TurndownService {
  private readonly turndownForWhatService: TurndownForWhat;

  constructor() {
    this.turndownForWhatService = this.initTurndownForWhatService();
  }

  turndown(html: string): string {
    return this.turndownForWhatService.turndown(html);
  }

  private initTurndownForWhatService(): TurndownForWhat {
    const turndownForWhatService = new TurndownForWhat();

    turndownForWhatService.addRule('notes_formatting', {
      filter: ['span', 'em', 'strong', 'u'],
      replacement: (content, node) => {
        const backgroundColor = node.style.backgroundColor;
        const formattedContent = content.trim();

        // Highlighting is applied as a background-color css style. If it's alone, it will be in a span tag. If it is accompanied
        // by another text style, it will be inside that style's corresponding tag.
        switch (node.tagName) {
          case 'EM':
            return backgroundColor ? `*==${formattedContent}==*` : `*${formattedContent}*`; // Italic with/without highlight
          case 'STRONG':
            return backgroundColor ? `**==${formattedContent}==**` : `**${formattedContent}**`; // Bold with/without highlight
          case 'U':
            return backgroundColor ? `++==${formattedContent}==++` : `++${formattedContent}++`; // Underlined with/without highlight
          default:
            return backgroundColor ? `==${formattedContent}==` : formattedContent; // Just highlighted or no formatting
        }
      },
    });

    return turndownForWhatService;
  }
}
